"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _O7FALLU5cjs = require('./O7FALLU5.cjs');



var _MLKK6UGOcjs = require('./MLKK6UGO.cjs');


var _EV33XSIBcjs = require('./EV33XSIB.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/select/select-store.ts
var _selectstore = require('@ariakit/core/select/select-store'); var Core = _interopRequireWildcard(_selectstore);
function useSelectStoreOptions(props) {
  const combobox = _EV33XSIBcjs.useComboboxProviderContext.call(void 0, );
  props = {
    ...props,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  };
  return _MLKK6UGOcjs.useCompositeStoreOptions.call(void 0, props);
}
function useSelectStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.combobox]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "value", "setValue");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "setValueOnMove");
  return Object.assign(
    _O7FALLU5cjs.usePopoverStoreProps.call(void 0, 
      _MLKK6UGOcjs.useCompositeStoreProps.call(void 0, store, update, props),
      update,
      props
    ),
    { combobox: props.combobox }
  );
}
function useSelectStore(props = {}) {
  props = useSelectStoreOptions(props);
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createSelectStore, props);
  return useSelectStoreProps(store, update, props);
}





exports.useSelectStoreOptions = useSelectStoreOptions; exports.useSelectStoreProps = useSelectStoreProps; exports.useSelectStore = useSelectStore;
